import { render, staticRenderFns } from "./MenuItemBoxNotice.vue?vue&type=template&id=e871f584&"
import script from "./MenuItemBoxNotice.vue?vue&type=script&lang=js&"
export * from "./MenuItemBoxNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports